import React from 'react'

import { Wrapper, Label, StyledInput, StyledSelect, StyledTextArea, StyledError } from './styles'
import Grid from '../grid'

const handleInputWrapping = (Component, props) => {
  const { children, errorMessage, options, isValid, ...inputProps } = props

  return (
    <Wrapper>
      <Label>{children}</Label>

      {!options ? (
        <Component {...inputProps} />
      ) : (
        <Component {...inputProps}>
          <option></option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Component>
      )}

      <StyledError isValid={isValid}>{!isValid && (errorMessage || 'This field is not valid.')}</StyledError>
    </Wrapper>
  )
}

export const Input = props => handleInputWrapping(StyledInput, props)

export const Select = props => handleInputWrapping(StyledSelect, props)

export const TextArea = props => handleInputWrapping(StyledTextArea, props)

export const Checkbox = ({ children, errorMessage, isValid, ...inputProps }) => (
  <Wrapper>
    <Grid columns="auto 1fr" gap="0.5rem">
      <input type="checkbox" {...inputProps} />
      <label htmlFor={inputProps.name}>{children}</label>
    </Grid>

    <StyledError isValid={isValid}>{!isValid && (errorMessage || 'This field is not valid.')}</StyledError>
  </Wrapper>
)
